<template>
  <div class="forgetPassWordWarp">
    <ag-backHome></ag-backHome>
    <div class="forgetBox">
      <div class="titleWarp">
        <span class="title">
          找回密码
        </span>
      </div>
      <div class="inputBox">
        <div class="inputWarp code loginCode" style="margin-right: 0">
          手机号 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="number" placeholder="输入您的手机号" v-model="phoneNum">
        </div>
        <getPhoneCode v-on:getCode="setCode" :type="2" :phoneNumber="phoneNum"></getPhoneCode>
        <div class="inputWarp">
          验证码 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="text" placeholder="输入手机验证码" v-model="phoneCodeNum">
        </div>
        <div class="inputWarp">
          新密码 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="password" placeholder="输入新密码" v-model="newPas">
        </div>
        <div class="inputWarp">
          确认密码 <input type="password" placeholder="确认重复密码" v-model="againPas" style="padding-left: 10px">
        </div>
        <div class="loginBtn" @click="sub">提交</div>
      </div>
    </div>
    <ag-footer></ag-footer>
  </div>
</template>
<script type="text/ecmascript-6">
  import getPhoneCode from '../../modules/phoneCode.vue'

  export default {
    data() {
      return {
        phoneCodeNum: '',
        newPas: '',
        againPas: '',
        phoneNum: '',
        system:''
      }
    },
    components: {
      getPhoneCode
    },
    methods: {
      setCode(data){
        this.system = data.code
      },
      sub() {
        let _this = this;
        if (_this.phoneNum == '') {
          _this.$message({
            message: "请输入手机号",
            type: 'warning'
          });
        }
        else if (_this.phoneNum.length != 11) {
          _this.$message({
            message: "请输入11位手机号码",
            type: 'warning'
          });
        }
        else if (_this.phoneCodeNum == '') {
          _this.$message({
            message: "请输入验证码",
            type: 'warning'
          });
        }
        else if (_this.newPas == '') {
          _this.$message({
            message: "请输入新密码",
            type: 'warning'
          });
        }
        else if (_this.againPas == '') {
          _this.$message({
            message: "请输入重复密码",
            type: 'warning'
          });
        }
        else if (_this.againPas != _this.newPas) {
          _this.$message({
            message: "重复密码不正确",
            type: 'warning'
          });
        }else if (_this.system!='请求成功') {
          _this.$message({
            message:'验证码发送成功',
            type: 'warning'
          });
        } else {
          _this.ajpost('/api/account/forgetPassword',{
            "code": _this.phoneCodeNum,
            "mobile": _this.phoneNum,
            "password": _this.newPas
          },
          function (data) {
            if(data.code ==0){
              _this.$message({
                message: "修改成功",
                type: 'success'
              });
              _this.$router.push('/login')
            }else {
              _this.$message({
                message: data.msg,
                type: 'warning'
              });
            }
          })
        }
      }
    }
  }
</script>
<style>
  @import "../../../assets/less/loginHeader.css";
</style>



// WEBPACK FOOTER //
// src/components/home/forgetPassWord/forgetPassWord.vue